module.exports = {
    "Click here to access XXL features": "Abonnez vous!",
    "Single period, without automatic rebilling. Immediate access!": "Période unique, sans renouvellement automatique, accès immédiat!",
    "Single payment, without automatic rebilling. Immediate access!": "Achat unique, sans renouvellement automatique, accès immédiat!",

    '<span class="XXL">XXL</span> Membership' : 'Fonctions <span class="XXL">XXL</span>',

    '%1 token': '%1 jeton',
    '%1 tokens': '%1 jetons',
    '%1 free tokens': '%1 jetons gratuits',
    'in your virtual wallet!': 'dans votre porte monnaies virtuel!',

    "Viewing all webcams without limits": "Affichage de toutes les webcams en illimités",
    "Full-screen viewing of webcams": "Affichage en plein écran des webcams",
    "Private messages (PM) feature": "Fonction message privé (MP)",
    "Private room creation": "Création de salles privées",
    "Access to full rooms": "Accès aux salles pleines",

    "All features in the mail": "Toutes les fonctions de la messagerie",
    "All features of the profile page": "Toutes les fonctions de la page profil",
    "Access to all amateur videos": "Lecture de tous les vidéos amateurs",
    "Access to all photos": "Affichage de toutes les photos",
    "Blocking unwanted users": "Blocage des utilisateurs indésirables",
    "Participation in collective moderation": "Participation à la modération collective",
    "And a lot more...": "Et plus encore...",

    '%1 days': '%1 jours',
    "You can attach a message to %1, if you want:": "Vous pouvez, si vous le souhaitez, adresser un message à %1 :",
    'More information about Functions XXL': 'Plus de détails concernant les fonctions XXL',

    'Your payment has been done successfully.': 'Votre paiement a été accepté.',
    'Details of your transaction:': 'Détails de votre transaction :',
    'Amount:': 'Montant débité :',
    'Credit card number:': 'Numéro de carte bancaire :',
    'Reference of your transaction:': 'Référence de la transaction :',
    'A message has been sent to the following email address:': 'Un message vous a été envoyé à l\'adresse email suivante:',
    'Continue': 'Continuer',
    'Single payment, <em>without automated renewal</em>. You will be charged <strong>only</strong> once.': 'Achat unique, <em>sans renouvellement automatique</em>. Vous serez débité une <strong>seule</strong> fois.',
    'Secure server, payment page is encrypted with 256-bit SSL.': 'Serveur sécurisé, protocole 3-D Secure, page de paiement cryptée SSL 256-bit.',
    'Expiration date:': 'Date d\'expiration :',
    'Security code:': 'Code de sécurité :',
    'This code consists of the last 3 digits at the back side of most credit cards.': 'Le cryptogramme est composé des 3 derniers chiffres du numéro présent au dos de la plupart des cartes bancaires.',
    'Your email address:': 'Votre adresse email :',
    'Your payment confirmation will be sent to this email address. Be sure to specify a valid address to receive this message.': 'Votre confirmation de paiement vous sera envoyé à cette adresse email. Prenez soin d\'indiquer une adresse valide afin de recevoir ce message.',
    'Check your SPAM folder if you do not receive this message in your inbox.': 'Consultez votre dossier SPAM si vous ne recevez pas ce message dans votre boite de reception.',
    'Confirm your payment': 'Confirmez votre paiement',
    '01 - January': '01 - Janvier',
    '02 - February': '02 - Février',
    '03 - March': '03 - Mars',
    '04 - April': '04 - Avril',
    '05 - May': '05 - Mai',
    '06 - June': '06 - Juin',
    '07 - July': '07 - Juillet',
    '08 - August': '08 - Août',
    '09 - September': '09 - Septembre',
    '10 - October': '10 - Octobre',
    '11 - November': '11 - Novembre',
    '12 - December': '12 - Décembre',

    'Payment history': 'Historique des paiements',
    "Purchase date": "Date d'achat",
    "Ticket number": "Numéro de ticket",
    "Paid by": "Payé par",
    "Period of XXL": "Durée du XXL",

    "You have no payments yet.": "Vous n'avez pas encore de paiements.",

    "Back to payments history": "Retour à l'historique des paiements",
    "Your XXL subscription is active till": "Votre abonnement XXL expire le",
    "Buy more XXL": "Prolonger mon XXL",
    "Please wait, your payment is being processed...": "Veuillez patienter, votre opération de paiement est en cours ...",
    "Give XXL membership": "Offrez un abonnement XXL",
    "Buy XXL Membership": "Achetez un abonnement XXL",
    "Choose what XXL plan you'll give to <strong>%1</strong>": "Choisissez la durée de l'abonnement XXL que vous allez offrir à <strong>%1</strong>",
    "Choose your XXL plan": "Choisissez la durée de votre abonnement XXL",

    'You need <strong>%1 tokens</strong> to buy %2': 'Vous avez besoin de <strong>%1 jetons</strong> pour offrir ce cadeau virtuel %2', // xxl

    'Bonus XXL': 'Bonus XXL',
    'Credit Card': 'Porte monnaie',
    'Gift': 'Cadeau',
    'Virtual gift': 'Cadeau virtuel',
    'Virtual gift for': 'Cadeau virtuel pour',

    'Credit': 'Crédit',
    'Debit': 'Débit',
    'Description': 'Description',
    'Total': 'Total',

    'Replenish your wallet': 'Créditer mon porte monnaie virtuel',
};


// WEBPACK FOOTER //
// ./src/l10n-messages/fr/xxl.js